var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeeboltHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4509 20.6124C58.7958 19.5513 61.5534 20.0534 63.375 21.875C65.1966 23.6966 65.6987 26.4542 64.6376 28.7991L59.0899 41.0614C58.8153 41.6708 58.6722 42.3305 58.6722 43C58.6722 43.6695 58.8153 44.3293 59.0899 44.9387L64.6376 57.2009C65.6987 59.5457 65.1966 62.3034 63.375 64.125C61.5534 65.9466 58.7957 66.4487 56.4509 65.3876L44.1886 59.8399C43.5793 59.5653 42.9195 59.4222 42.25 59.4222C41.5805 59.4222 40.9208 59.5653 40.3114 59.8399L28.0491 65.3876C25.7042 66.4487 22.9466 65.9466 21.125 64.125C19.3034 62.3034 18.8013 59.5458 19.8624 57.2009L25.4101 44.9386C25.6847 44.3292 25.8278 43.6695 25.8278 43C25.8278 42.3305 25.6847 41.6707 25.4101 41.0614L19.8624 28.7991C18.8013 26.4543 19.3034 23.6966 21.125 21.875C22.9466 20.0534 25.7043 19.5513 28.0491 20.6124L40.3113 26.1601C40.9207 26.4347 41.5805 26.5778 42.25 26.5778C42.9195 26.5778 43.5792 26.4347 44.1886 26.1601L56.4509 20.6124Z",
    fill: "url(#paint0_linear_1_9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1296 20.2043H68.2761V66.0272H59.1115L26.2499 32.9038V66.0272H16.1034V20.2043H27.2319L58.1296 51.6257V20.2043Z",
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9",
    x1: 63.375,
    y1: 21.875,
    x2: 21.125,
    y2: 64.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A31FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeboltHub);
export default __webpack_public_path__ + "static/media/beebolt-hub.90d38eefc3a139b9861d19c939db5494.svg";
export { ForwardRef as ReactComponent };